const transactionTypes = {
  ADD_PARTNER: 'ADD_PARTNER',
  CONSTITUTION: 'CONSTITUTION',
  CAPITAL_INCREASE: 'CAPITAL_INCREASE',
  CAPITAL_DECREASE: 'CAPITAL_DECREASE',
  HERITAGE: 'HERITAGE',
  DONATION: 'DONATION',
  TRANSMISSION: 'TRANSMISSION',
  BUY: 'BUY',
  SELL: 'SELL',
  SPLIT: 'SPLIT',
  RENUMERATION: 'RENUMERATION',
  RECLASSIFICATION: 'RECLASSIFICATION',
  ENTIRE_CLASS_RECLASSIFICATION: 'ENTIRE_CLASS_RECLASSIFICATION',
};

module.exports = transactionTypes;
